export default "__VITE_ASSET__XFqCoYUN__"